import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function Privacy() {
  useEffect(() => {
    document.title = 'Privacy Policy | Audacious Quest PTE Ltd';
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      {/* Page Heading */}
      <section className="py-8 md:py-12 px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading text-primary-900 mb-4">
            Privacy Policy
          </h1>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            Learn how we collect, use, and protect your data
          </p>
        </div>
      </section>

      {/* Privacy Content */}
      <section className="py-8 md:py-12 px-4 md:px-6">
        <div className="max-w-3xl mx-auto space-y-10 text-foreground-700 text-sm md:text-base leading-relaxed">
          {/* Who we are */}
          <div>
            <h2 className="text-xl md:text-2xl font-heading text-primary-900 mb-4">Who we are</h2>
            <p>
              Our website address is:{' '}
              <a
                href="https://www.audaciousquestpl.com/Audacious"
                className="text-accent-600 hover:text-accent-700 transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.audaciousquestpl.com/Audacious
              </a>
            </p>
          </div>

          {/* Comments */}
          <div>
            <h2 className="text-xl md:text-2xl font-heading text-primary-900 mb-4">Comments</h2>
            <p>
              When visitors leave comments on the site we collect the data shown in the comments
              form, and also the visitor&apos;s IP address and browser user agent string to help
              spam detection.
            </p>
            <p className="mt-3">
              An anonymized string created from your email address (also called a hash) may be
              provided to the Gravatar service to see if you are using it. The Gravatar service
              privacy policy is available here:{' '}
              <a
                href="https://automattic.com/privacy/"
                className="text-accent-600 hover:text-accent-700 transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://automattic.com/privacy/
              </a>
              . After approval of your comment, your profile picture is visible to the public in
              the context of your comment.
            </p>
          </div>

          {/* Media */}
          <div>
            <h2 className="text-xl md:text-2xl font-heading text-primary-900 mb-4">Media</h2>
            <p>
              If you upload images to the website, you should avoid uploading images with embedded
              location data (EXIF GPS) included. Visitors to the website can download and extract
              any location data from images on the website.
            </p>
          </div>

          {/* Cookies */}
          <div>
            <h2 className="text-xl md:text-2xl font-heading text-primary-900 mb-4">Cookies</h2>
            <p>
              If you leave a comment on our site you may opt-in to saving your name, email address
              and website in cookies. These are for your convenience so that you do not have to fill
              in your details again when you leave another comment. These cookies will last for one
              year.
            </p>
            <p className="mt-3">
              If you visit our login page, we will set a temporary cookie to determine if your
              browser accepts cookies. This cookie contains no personal data and is discarded when
              you close your browser.
            </p>
            <p className="mt-3">
              When you log in, we will also set up several cookies to save your login information
              and your screen display choices. Login cookies last for two days, and screen options
              cookies last for a year. If you select &quot;Remember Me&quot;, your login will
              persist for two weeks. If you log out of your account, the login cookies will be
              removed.
            </p>
            <p className="mt-3">
              If you edit or publish an article, an additional cookie will be saved in your browser.
              This cookie includes no personal data and simply indicates the post ID of the article
              you just edited. It expires after 1 day.
            </p>
          </div>

          {/* Embedded content */}
          <div>
            <h2 className="text-xl md:text-2xl font-heading text-primary-900 mb-4">
              Embedded content from other websites
            </h2>
            <p>
              Articles on this site may include embedded content (e.g. videos, images, articles,
              etc.). Embedded content from other websites behaves in the exact same way as if the
              visitor has visited the other website.
            </p>
            <p className="mt-3">
              These websites may collect data about you, use cookies, embed additional third-party
              tracking, and monitor your interaction with that embedded content, including tracking
              your interaction with the embedded content if you have an account and are logged in to
              that website.
            </p>
          </div>

          {/* Who we share your data with */}
          <div>
            <h2 className="text-xl md:text-2xl font-heading text-primary-900 mb-4">
              Who we share your data with
            </h2>
            <p>
              If you request a password reset, your IP address will be included in the reset email.
            </p>
          </div>

          {/* How long we retain your data */}
          <div>
            <h2 className="text-xl md:text-2xl font-heading text-primary-900 mb-4">
              How long we retain your data
            </h2>
            <p>
              If you leave a comment, the comment and its metadata are retained indefinitely. This
              is so we can recognize and approve any follow-up comments automatically instead of
              holding them in a moderation queue.
            </p>
            <p className="mt-3">
              For users that register on our website (if any), we also store the personal
              information they provide in their user profile. All users can see, edit, or delete
              their personal information at any time (except they cannot change their username).
              Website administrators can also see and edit that information.
            </p>
          </div>

          {/* What rights you have over your data */}
          <div>
            <h2 className="text-xl md:text-2xl font-heading text-primary-900 mb-4">
              What rights you have over your data
            </h2>
            <p>
              If you have an account on this site, or have left comments, you can request to receive
              an exported file of the personal data we hold about you, including any data you have
              provided to us. You can also request that we erase any personal data we hold about
              you. This does not include any data we are obliged to keep for administrative, legal,
              or security purposes.
            </p>
          </div>

          {/* Where your data is sent */}
          <div>
            <h2 className="text-xl md:text-2xl font-heading text-primary-900 mb-4">
              Where your data is sent
            </h2>
            <p>
              Visitor comments may be checked through an automated spam detection service.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}